import TeachList from './List'
import { getAllTech } from '@/network/requests/techInfo'
import { techGroupDetailRequest, techGroupRequest } from '@/network/requests/techGroup'

export default {
	name: 'TechGroup',
	components: {
		TeachList,
	},
	data() {
		/**
		 * 工艺参数组重名检查。
		 * @param {*} rule
		 * @param {*} value
		 * @param {*} callback
		 */
		var validateTechGroupNameExist = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入工艺参数组名称'))
			} else {
				var msg = '工艺参数组名称已经存在，请更换名称。'
				//检查名称是否重复。
				techGroupRequest.queryAll({ name: value }).then(res => {
					if (res.length > 1) {
						callback(new Error(msg))
					} else if (res.length == 1) {
						var data = res[0]

						if (this.form._id) {
							if (data._id.$oid != this.form._id.$oid) {
								callback(new Error(msg))
							} else {
								callback()
							}
						} else {
							callback(new Error(msg))
						}
					} else {
						callback()
					}
				})
			}
		}

		return {
			total: 0,
			totalPage: 0,
			pagesize: 10,
			page: 1,
			nameSearch: '',
			showDialogModify: false,
			formTitle: '',
			form: {},
			formRules: {
				name: [{ validator: validateTechGroupNameExist, trigger: 'blur' }],
			},
			modifying: false,
			tableData: [],
			pageLoading: false,
			showTechConfig: false,
			configuringGroup: {},
			currentConfigDetail: [],
			screenWidth: 0,
			screenHeight: 0,
			techList: [],
			teachGroupDetails: [],
		}
	},
	methods: {
		/**
		 * 选择工艺参数。
		 * @param {*} param0
		 */
		handleSelect({ _id: { $oid }, name }) {
			var data = {
				tech_group_id: this.configuringGroup._id.$oid,
				tech_id: $oid,
				tech_name: name,
				tech_group_name: this.configuringGroup.name,
			}

			//保存工艺参数。
			techGroupDetailRequest.upload(data).finally(() => {
				this.loadTechGroupConfig()

				//更新工艺参数组列表。
				this.loadPage()
			})
		},
		/**
		 * 取消选择工艺参数。
		 * @param {*} param0
		 */
		handleCancelSelect({ _id: { $oid } }) {
			//console.log('techGroupDetailRequest', techGroupDetailRequest)
			techGroupDetailRequest
				.deleteBatch({
					tech_id: $oid,
					tech_group_id: this.configuringGroup._id.$oid,
				})
				.finally(() => {
					this.loadTechGroupConfig()

					//更新工艺参数组列表。
					this.loadPage()
				})
		},
		/**
		 * 配置工艺参数。
		 * @param {*} group
		 */
		showConfig(group) {
			const {
				_id: { $oid },
			} = group
			this.configuringGroup = group
			this.loadTechGroupConfig()
		},
		/**
		 * 加载工艺参数组详情。
		 */
		loadTechGroupConfig() {
			//显示工艺参数详情对话框。
			this.showTechConfig = true
			//加载工艺组
			techGroupDetailRequest.queryAll({ tech_group_id: this.configuringGroup._id.$oid }).then(res => {
				this.currentConfigDetail = res
				console.log('loadTechGroupConfig', res)
			})
		},
		/**
		 * 切换页码。
		 */
		onCurrentChange(page) {
			this.pageLoading = true
			this.page = page
			this.loadPage()
		},
		/**
		 * 切换每页记录数量。
		 */
		handleSizeChange(size) {
			this.pagesize = size
			this.page = 1
			this.loadPage()
		},
		/**
		 * 添加工艺参数组。
		 */
		handleAdd() {
			this.showDialogModify = true
			this.formTitle = '新增工艺参数组'
			this.form = {
				name: '',
			}
		},
		/**
		 * 工艺参数组表单验证。
		 * @param {*} callback
		 */
		teachGroupFormValidate(callback) {
			this.$refs['teachGroupForm'].validate(callback)
		},
		/**
		 * 保存工艺参数组。
		 */
		handleSubmit() {
			if (this.modifying) {
				return
			} else {
				this.modifying = true
			}

			this.teachGroupFormValidate(valid => {
				console.log('保存工艺参数组')

				if (valid) {
					techGroupRequest
						.upload({ ...this.form })
						.then(res => {
							console.log('保存工艺参数组', res)
						})
						.finally(() => {
							this.showDialogModify = false
							this.showTechConfig = false
							this.search()

							setTimeout(() => {
								this.modifying = false
							}, 1000)
						})
				} else {
					this.modifying = false
				}
			})
		},
		/**
		 * 修改工艺参数组名称。
		 */
		handleEdit({ name, _id }) {
			this.formTitle = '修改工艺参数组名称'
			this.form = { name, _id }
			this.showDialogModify = true
		},
		/**
		 * 删除工艺参数组。
		 * @param {*} param0
		 */
		handleDelete({ _id: { $oid } }) {
			techGroupRequest
				.deleteById($oid)
				.then(res => {
					console.log('删除工艺参数组', res)
				})
				.finally(() => {
					this.search()
				})
		},
		/**
		 * 获取过滤条件。
		 */
		getFilter() {
			let filter
			if (this.nameSearch) {
				filter = {
					name: this.nameSearch,
				}
			}

			return filter
		},
		/**
		 * 加载工艺参数组。
		 */
		loadPage() {
			let filter = this.getFilter()
			techGroupRequest
				.searchPage(this.pagesize, this.page, filter)
				.then(({ data }) => {
					this.total = data._size
					this.totalPage = data._total_pages

					var idArray = data._embedded.map(p => p._id.$oid)
					var filter = { tech_group_id: { $in: idArray } }
					var tempArray = data._embedded

					//加载工艺参数
					techGroupDetailRequest
						.queryAll(filter)
						.then(tech_groups => {
							console.log('加载所有工艺参数', tech_groups)
							this.teachGroupDetails = tech_groups

							//补充工艺参数。
							tempArray.forEach((v, i) => {
								v.techList = this.teachGroupDetails.filter(t => t.tech_group_id == v._id.$oid)
							})

							this.tableData = tempArray
						})
						.finally(() => {
							this.pageLoading = false
						})
				})
				.finally(() => {})
		},
		/**
		 * 搜索工艺。
		 */
		search() {
			this.pageLoading = true
			this.page = 1
			this.loadPage()
		},
	},
	created() {
		this.pageLoading = true
		getAllTech()
			.then(res => {
				console.log('加载所有的工艺信息', res)
				//工艺信息加载完成后，再加载工艺参数组信息。
				this.techList = res
				this.loadPage()
			})
			.finally(() => {})
	},
}
